import "./Ac.css"
import Product1 from "../Components/Product1"
import Alexa from "../images/alexa.jpg"
import Ac1 from "../images/ac1.jpg"
import Ac2 from "../images/ac2.jpg"
import Ac3 from "../images/ac3.jpg"
import Ac4 from "../images/ac4.jpg"
import Ac5 from "../images/ac5.jpg"
import Ac6 from "../images/ac6.jpg"
import Ac7 from "../images/ac7.jpg"
import Ac8 from "../images/ac8.jpg"
import Ac9 from "../images/acadd.jpg"



export default function Ac() {

  return (
    <div className="stdivinhome">

<div className="add"><img src={Ac9} /></div>
          
                   

      <div className="home">

        <div className="home__prd">

          <div className="home__prd1">

            <Product1 id="ac1" prdName="LG" img={Ac1} price=" Price : ₹ 5580" review="5.5" buttonCart="Add to cart"  ></Product1>
              <Product1 id="ac2"  prdName="HAIER" img={Ac2} price="Price : ₹ 5580" review="5.5" buttonCart="Add to cart"></Product1>          

          </div>

          <div className="home__prd1">

          
          <Product1 id="ac3"  prdName="BLUESTAR" img={Ac3} price="Price : ₹ 5580" review="5.5" buttonCart="Add to cart"></Product1>
            <Product1  id="ac4" prdName="SAMSUNG" img={Ac4} price=" Price : ₹ 5580" review="5.5" buttonCart="Add to cart"></Product1>
        

          </div>

        </div>


        <div className="home__prd">

          <div className="home__prd1">

            <Product1 id="ac5"  prdName="ONIDA" img={Ac5} price=" Price : ₹ 5580" review="5.5" buttonCart="Add to cart"  ></Product1>
            <Product1 id="ac6" prdName="HAIER3" img={Ac6} price=" Price : ₹ 5580" review="5.5" buttonCart="Add to cart"></Product1>

          </div>

          <div className="home__prd1">

            <Product1 id="ac7"  prdName="BLUSTAR" img={Ac7} price=" Price : ₹ 5580" review="5.5" buttonCart="Add to cart"></Product1>
            <Product1 id="ac8"  prdName="WHIRLPOOL" img={Ac8} price=" Price : ₹ 5580" review="5.5" buttonCart="Add to cart"></Product1>

          </div>

        </div>

      </div>

    </div>
  )
}